var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-icon',{staticClass:"ma-2 pa-2 award-icon",class:{ 'elevation-4': hover },attrs:{"size":"48","color":_vm.color},on:{"mouseover":function($event){return _vm.$emit('mouseover')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},[_vm._v("\n    "+_vm._s(_vm.icon)+"\n  ")])}}])})}
var staticRenderFns = []

export { render, staticRenderFns }